// action
import {
    SAVE_APPOINTMENT,
    SAVE_APPOINTMENT_FAIL,
    SAVE_APPOINTMENT_SUCCESS,
    SAVE_APPOINTMENT_RESET
} from '../action/saveAppointmentAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SAVE_APPOINTMENT:
            return {
                ...state,
                apiState: "loading"
            }
        case SAVE_APPOINTMENT_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SAVE_APPOINTMENT_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
                data: action.response.data.data.result
            }
        case SAVE_APPOINTMENT_RESET:
            return initialState
        default:
            return state
    }
}